import { render, staticRenderFns } from "./LegalTerms.vue?vue&type=template&id=1492180d&"
import script from "./LegalTerms.vue?vue&type=script&lang=js&"
export * from "./LegalTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports